import React from 'react';
import { Page } from '../Page';
import { ShieldCheck, Award } from 'lucide-react';
export function PageSupplementQuality() {
  return <Page pageNumber={13} variant="light" data-id="element-1641" data-mp="1jye0vkonr9w2">
      <div className="flex flex-col h-full" data-id="element-1642" data-mp="1xwkma1cf7heu">
        {/* Hero Image */}
        <div className="h-[180px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-1643" data-mp="1xuhogv510jzk">
          <img src="https://images.unsplash.com/photo-1584017911766-d451b3d0e843?w=1000&q=80" alt="Supplements and vitamins" className="w-full h-full object-cover" data-id="element-1644" data-mp="1svy42z62zg9b" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/40 to-transparent" data-id="element-1645" data-mp="22vf9dfhf7s4r" />
        </div>

        <div className="mb-6" data-id="element-1646" data-mp="2clgupzie2wfz">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1647" data-mp="2cl8i88q6ht5b">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1648" data-mp="2qljang74zfsl">
            Supplement <span className="text-tealslate" data-id="element-1649" data-mp="2lnq60rlhetuf">Quality</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1650" data-mp="48d2v7h3ts5z" />
        </div>

        <div className="grid grid-cols-2 gap-10 mb-8" data-id="element-1651" data-mp="96eh9f3l53b4">
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1652" data-mp="96y1j2gpk3sb">
            The supplement industry is largely unregulated. What's on the label
            isn't always what's in the bottle. When you're eating less and
            relying on supplements to fill critical nutritional gaps, you cannot
            afford to take products that don't absorb or contain fillers.
          </p>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1653" data-mp="s3z98v1nchzy">
            Your body is already under stress from rapid weight loss and reduced
            food intake. Adding unknown contaminants, heavy metals, or
            inaccurate dosing on top of that is an unnecessary risk. You need to
            know exactly what you are putting into your body.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-6 mb-8" data-id="element-1654" data-mp="1awtfn0l7f1sk">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1655" data-mp="1atfajkl5oehf">
            <div className="w-10 h-10 rounded-full bg-tealslate/20 border border-tealslate/40 flex items-center justify-center mb-3" data-id="element-1656" data-mp="36zg470r5c5lp">
              <ShieldCheck className="w-5 h-5 text-tealslate" data-id="element-1657" data-mp="3gopuqc6cdg7p" />
            </div>
            <h3 className="text-lg font-serif text-[#1F1F1F] mb-2" data-id="element-1658" data-mp="3gqsu3mtdwlp3">
              NSF Certified for Sport
            </h3>
            <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1659" data-mp="3qmng8rwtgywm">
              Tests for label accuracy, screens for contaminants, and tests for
              banned substances. The gold standard used by professional and
              Olympic athletes.
            </p>
          </div>
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5" data-id="element-1660" data-mp="3ftra81qntjf">
            <div className="w-10 h-10 rounded-full bg-navyslate/40 border border-navyslate/60 flex items-center justify-center mb-3" data-id="element-1661" data-mp="3up0kfbvx0ora">
              <Award className="w-5 h-5 text-tealslate" data-id="element-1662" data-mp="20ahj3cn40rau" />
            </div>
            <h3 className="text-lg font-serif text-[#1F1F1F] mb-2" data-id="element-1663" data-mp="20cau144r9xon">
              Informed Choice
            </h3>
            <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1664" data-mp="furudnzl2ewv">
              An independent batch testing program for banned substances and
              contaminants. Trusted globally by athletes and healthcare
              providers.
            </p>
          </div>
        </div>

        <div className="flex-1 flex items-end" data-id="element-1665" data-mp="azvxoajej3df">
          <div className="border-l-4 border-tealslate pl-6 py-2" data-id="element-1666" data-mp="3t6sf9r6nwttr">
            <p className="text-base font-serif italic text-[#1F1F1F] leading-relaxed mb-2" data-id="element-1667" data-mp="3t9of5l22lsku">
              "If a supplement company will not pay for third-party testing, ask
              yourself why."
            </p>
            <p className="text-xs text-[#7A7A70]" data-id="element-1668" data-mp="3o7z0lvfn2ws0">
              We recommend <strong className="text-[#1F1F1F]" data-id="element-1669" data-mp="3oabiy9pb795l">Thorne</strong>,
              NSF Certified for Sport, pharmaceutical-grade standards.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}